import { combineReducers } from "redux";
import authReducer from "./slice/auth.slice.js";
import userReducer from "./slice/user.slice.js";
import categoryReducer from "./slice/category.slice.js";
import projectReducer from "./slice/project.slice.js";
import inquiryReducer from "./slice/inquiry.slice.js";
import careerReducer from "./slice/career.slice.js";

export const rootReducer = combineReducers({
    auth: authReducer,
    users: userReducer,
    category: categoryReducer,
    project: projectReducer,
    inquiry: inquiryReducer,
    career: careerReducer,
});

